import { atom, selector } from "recoil";
import { isValidSlug } from "../utils/forms";
import { Skill, SkillRequestTouched } from "../types/jobs";
import {
  JOB_SKILL_DEFAULTS,
  JOB_SKILL_TOUCHED_DEFAULTS,
} from "../constants/jobSkills";

export const updateSkillsState = atom<string | undefined>({
  key: "app.jobs.skills.update",
  default: undefined,
});

export const editSkillState = atom<Skill>({
  key: "app.jobs.skills.edit",
  default: JOB_SKILL_DEFAULTS,
});

export const editSkillTouchedState = atom<SkillRequestTouched>({
  key: "app.jobs.skills.edit.touched",
  default: JOB_SKILL_TOUCHED_DEFAULTS,
});

export const editSkillValidState = selector<{
  [key in keyof Skill]: boolean;
}>({
  key: "app.jobs.skills.edit.valid",
  get: ({ get }) => {
    const fields = get(editSkillState);

    // SET ALL FIELDS TO BE VALID
    const validFields = Object.fromEntries(
      Object.keys(fields).map((key) => [key, true])
    ) as {
      [key in keyof Skill]: boolean;
    };

    // VALIDATE REQUIRED FIELDS
    if (!fields.name) {
      validFields.name = false;
    }
    if (!fields.slug) {
      validFields.slug = false;
    } else {
      validFields.slug = isValidSlug(fields.slug);
    }

    return validFields;
  },
});

export const editSkillErrorState = selector({
  key: "app.jobs.skills.edit.error",
  get: ({ get }) => {
    const validFields = get(editSkillValidState);
    return Object.values(validFields).some((valid) => !valid);
  },
});
